export default [
  {
    text: 'option.table.name',
    value: 'name',
    editable: true,
  },
  {
    text: 'option.table.description',
    value: 'description',
    hideOnMobile: true,
    editable: true,
  },
  {
    text: 'option.table.requiredAmount',
    value: 'requiredAmount',
    editable: true,
  },
  {
    text: 'option.table.article',
    value: 'articles',
    type: 'slot',
  },
  {
    text: 'option.table.limit',
    value: 'limit',
    hideOnMobile: true,
    editable: true,
  },
  {
    text: 'option.table.sortOrder',
    value: 'sortOrder',
    hideOnMobile: true,
    editable: true,
  },
  {
    text: 'option.table.hasMultiple',
    value: 'hasMultiple',
    type: 'slot',
    hideOnMobile: true,
  },
  {
    text: 'option.table.visible',
    value: 'visible',
    default: true,
    type: 'slot',
  },
];
